<template>
  <div 
    v-if="!loading"
    class="product">
    <ZenitBackground :slug="slug"/>
    <ProductGallery :slug="slug"/>
    <ProductText :slug="slug"/>
    <ProductCta 
      :slug="slug" 
      @open-wishlist="$_openWishlist"
      @change-step="$_changeStep"/>
    <ProductListingsTabs :slug="slug"/>
    <swiperPosts
      :overlineTitle="$t('academy.blockTitle')"
      :subTitle="$t('academy.blockSubtitle')"/>
    <glaxiFooter/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ZenitBackground from '@/components/ZenitBackground/ZenitBackground.vue'
import ProductGallery from '@/components/ProductGallery/ProductGallery.vue'
import ProductText from '@/components/ProductText/ProductText.vue'
import ProductCta from '@/components/ProductCta/ProductCta.vue'
import ProductListingsTabs from '@/components/ProductListingsTabs/ProductListingsTabs.vue'
import SwiperPosts from '@/components/SwiperPosts/SwiperPosts.vue'
import GlaxiFooter from '@/components/GlaxiFooter/GlaxiFooter.vue'

export default {
  name: 'Product',
  components: {
    ZenitBackground,
    ProductGallery,
    ProductText,
    ProductCta,
    ProductListingsTabs,
    SwiperPosts,
    GlaxiFooter
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'product'
    ]),
    ...mapGetters([
      'lang'
    ]),
    currentProduct: {
      get () {
        return this.product(this.slug)
      }
    },
    loading: {
      get () {
        return typeof this.currentProduct === 'undefined'
      }
    }
  },
  beforeRouteEnter (from, to, next) {
    next(async (vm) => {
	    await vm.loadData()
      if (typeof vm.currentProduct === 'undefined') vm.$router.replace({ name: `${vm.lang}.not-found-page` })
    })
  },
  beforeRouteUpdate (from, to, next) {
    this.loadData()
    next()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts'
    ]),
    async loadData () {
      try {
        await this.loadProducts()
      } catch (e) {
        // TODO sentry
      }
    },
    $_openWishlist () {
      this.$emit('open-wishlist')
    },
    $_changeStep (step) {
      this.$emit('change-step', step)
    }
  },
  metaInfo () {
    if (!this.loading) return {
      title: this.currentProduct.fields.seoTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.currentProduct.fields.seoDescription },
        { property: 'og:locale', content: this.lang },
        { property: 'og:title', content: this.currentProduct.fields.seoTitle },
        { property: 'og:description', content: this.currentProduct.fields.seoDescription },
        { property: 'og:url', content: `/${this.lang}/prodotto/${this.slug}` },
        { property: 'og:image', content: `${this.currentProduct.fields.mainPicture.fields.file.url}?w=1024&fit=scale` }
      ],
      link: [
        { rel: 'alternate', href: `${window.location.origin}/it/prodotto/${this.slug}`, hreflang: 'it' },
        { rel: 'alternate', href: `${window.location.origin}/en/product/${this.slug}`, hreflang: 'en' },
        { rel: 'canonical', href: location.protocol + '//' + location.host + location.pathname }
      ]
    }
    return {
      title: 'Loading...',
      meta: [
        { vmid: 'description', name: 'description', content: 'Loading...' },
        { property: 'og:locale', content: 'Loading...' },
        { property: 'og:title', content: 'Loading...' },
        { property: 'og:description', content: 'Loading...' },
        { property: 'og:url', content: 'Loading...' },
        { property: 'og:image', content: 'Loading...' }
      ],
      link: [
        { rel: 'alternate', href: 'Loading...', hreflang: 'it' },
        { rel: 'alternate', href: 'Loading...', hreflang: 'en' }
      ]
    }
  }
}
</script>

<style>

</style>
